import type {} from '@tanstack/react-query';

import { _get } from './Get';
import { _list } from './List';
import { _start } from './Start';

export namespace useImportTask {
  export const Get: typeof _get = _get;
  export const List: typeof _list = _list;
  export const Start: typeof _start = _start;
}
export { importTaskQueryKeys } from './queryKeys';
